import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SIconSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <circle r="16" cy={height} cx={width} fill="none" />
      <path
        d="M17.2085 14.603C14.5751 13.8589 13.793 13.4246 13.793 12.391C13.793 11.6503 14.4263 11.0073 16.1012 11.0073C17.399 10.9552 18.6662 11.4 19.6309 12.2463C19.7347 12.3506 19.9043 12.2665 19.9769 12.2059L21.4546 10.7144C21.5411 10.6336 21.4996 10.5292 21.4131 10.4046C20.2676 8.94346 18.1463 8.46875 16.1323 8.46875C13.0767 8.46875 10.7236 9.81545 10.7236 12.4281C10.7236 15.0912 12.5472 16.246 15.987 17.2392C17.9595 17.7947 19.0392 18.229 19.0392 19.2794C19.0392 20.3299 17.8072 20.8887 16.2707 20.8887C14.6374 20.8887 13.1563 20.5521 11.9382 19.2996C11.8794 19.2222 11.7098 19.2592 11.6233 19.3636L10.0522 21.0773C10.0353 21.123 10.0325 21.1726 10.0442 21.2198C10.0559 21.2671 10.0815 21.31 10.118 21.3432C11.561 22.8953 13.8103 23.4912 16.077 23.4912C19.2641 23.4912 22.0013 22.1445 22.0013 19.2222C22.0013 16.4109 20.195 15.4615 17.2051 14.6198"
        fill={color}
      />
    </svg>
  );
};

export { SIconSvg };
